export default "__VITE_ASSET__8092b34f__"